import { SvgIcon } from '../Icon';
import KubitTooltip from '../KubitTooltip';

interface IProps {
  isActive?: boolean;
  tooltipText?: string;
}

const DerivedDefinitionIcon = ({ isActive, tooltipText }: IProps) => {
  return (
    <KubitTooltip content={tooltipText}>
      <SvgIcon
        name="function-x"
        width={16}
        height={16}
        isActive={isActive}
        customFill="currentColor"
      />
    </KubitTooltip>
  );
};

export default DerivedDefinitionIcon;
